import { useEffect } from 'react';

import { useCart } from '@sola/cart-sdk/store.js';
import { trackError } from '@sola/tracking/components/datalayer.js';

import { useDonate } from '../donate-context';

let cartFetched = false;
let listenersAdded = false;

export const useDonateValidation = () => {
  const { state } = useDonate();
  const {
    actions: { getCart },
  } = useCart('actions', 'cart');

  const getCurrentAmount = () => {
    if (state.selectedAmounts[state.donateFrequency] === 'other') {
      return state.otherAmounts[state.donateFrequency];
    }
    return state.selectedAmounts[state.donateFrequency];
  };

  const getValidationState = () => {
    const amount = getCurrentAmount();

    if (!amount) {
      return {
        isValid: false,
        isDisabled: false,
        message: undefined,
      };
    }

    if (state.submitError) {
      trackError(state.submitError.toString());
      return {
        isValid: false,
        isDisabled: false,
        message: state.submitError,
      };
    }

    return {
      isValid: true,
      isDisabled: false,
      message: undefined,
    };
  };

  useEffect(() => {
    const refreshCart = () => {
      if (getCart) {
        getCart();
        cartFetched = true;
      }
    };

    const handleFocus = () => {
      refreshCart();
    };

    const handleBeforeUnload = () => {
      cartFetched = false;
    };

    if (!cartFetched && getCart !== undefined) {
      refreshCart();
    }

    if (!listenersAdded && getCart !== undefined) {
      window.addEventListener('beforeunload', handleBeforeUnload);
      window.addEventListener('focus', handleFocus);
      listenersAdded = true;
    }
  }, [getCart]);

  const validationState = getValidationState();

  return {
    getCurrentAmount,
    getValidationState,
    validationState,
  };
};
